/**
 * Safe deep property read.
 *
 * sha-el-design's `nestedAccess` is typed for at most three property names,
 * and the report nodes go deeper than that
 * (workHistory.work.caller.employee.name). Same semantics: undefined rather
 * than a TypeError anywhere along the path.
 */
export const deep = (obj: any, ...path: string[]): any =>
  path.reduce((acc, key) => (acc === null || acc === undefined ? acc : acc[key]), obj);

/**
 * The summarised report's count fields are declared in schema.d.ts as
 * resolver functions taking { dateRange }, because they accept an argument.
 * Over the wire they arrive as plain numbers.
 */
export const num = (value: any): number => (typeof value === 'number' ? value : 0);
